import { Redirect, useParams } from "react-router-dom";

import { useAuthContext } from "@/components/AuthProvider";
import { PRACTITIONER } from "@/core/constants";
import { CMP_SHOP_TAB_URL } from "@/core/urls";
import useCmpRelatedUrl from "@/hooks/organisations/useCmpRelatedUrl";

export default function RedirectPractitioners({ children, tab }) {
  // We rely on the auth context user (not AppState's userInfo) because it is
  // populated both on initial load (via /api/get-user) and immediately after a
  // client side login (via the log in mutation). AppState's userInfo is a
  // no-cache query that isn't refetched after login, so it can be stale here.
  const { user } = useAuthContext();
  const { slug } = useParams();

  const { resolvedUrls } = useCmpRelatedUrl();

  if (user?.practitionerProfile?.tier === PRACTITIONER) {
    if (slug) {
      return (
        <Redirect to={`${resolvedUrls[CMP_SHOP_TAB_URL].replace(":tab", tab)}?slug=${slug}`} />
      );
    } else {
      return <Redirect to={`${resolvedUrls[CMP_SHOP_TAB_URL].replace(":tab", tab)}`} />;
    }
  }

  return children;
}
